exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nextButton[data-v-563bfbdd],.prevButton[data-v-563bfbdd]{display:block;width:210px;height:42px;line-height:42px;padding:0;margin:0 auto;color:#fff;font-weight:700;text-align:center;background-color:#cf798a;border:none;border-radius:8px;cursor:pointer}.prevButton[data-v-563bfbdd]{color:#333;background-color:#d9d9d9}", ""]);

// exports
